import { useState, useEffect, useCallback } from 'react'
import { CONSTANTS } from '../constants'

const usePayment = (url: string, amount: number, documentId: string, connectedAccountId?: string, isDeposit?: boolean, isEstimate?: boolean, tipAmount?: number) => {
    const [paymentIntent, setPaymentIntent] = useState<{
        clientSecret: string,
        price: number
    }>()
    const [error, setError] = useState<string | null>(null)
    const [loading, setLoading] = useState<boolean>(false)

    const fetchPaymentIntent = useCallback(async () => {
        setError(null)
        setLoading(true)

        console.log("🔄 Fetching payment intent:", { url, amount, tipAmount, documentId });
        const requestBody: any = {
            price: amount,
            collection: isEstimate ? CONSTANTS.FIREBASE.COLLECTIONS.ESTIMATES : CONSTANTS.FIREBASE.INVOICES.NAME,
            documentId: documentId,
            key: CONSTANTS.FIREBASE.INVOICES.COLUMNS.AMOUNT
        };

        if (connectedAccountId) {
            requestBody.connectedAccountId = connectedAccountId;
        }

        if (isDeposit) {
            requestBody.isDeposit = isDeposit;
        }

        if (tipAmount && tipAmount > 0) {
            requestBody.tipAmount = tipAmount;
        }

        try {
            const response = await fetch(`${url}/paymentIntent`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(requestBody)
            })

            const data = await response.json()

            if (!response.ok) {
                console.error("❌ Payment intent creation failed:", data);
                setError(data.message || CONSTANTS.ERRORS.PAYMENT_INTENT_FAILED);
                return;
            }

            if (!data.clientSecret) {
                console.error("❌ Payment intent response missing clientSecret:", data);
                setError(CONSTANTS.ERRORS.PAYMENT_INTENT_INVALID);
                return;
            }

            console.log("✅ Payment intent created:", data);
            setPaymentIntent(data)
        } catch (err) {
            console.error("❌ Payment intent fetch error:", err);
            setError(CONSTANTS.ERRORS.PAYMENT_INTENT_NETWORK);
        } finally {
            setLoading(false)
        }
    }, [url, amount, documentId, connectedAccountId, isDeposit, isEstimate, tipAmount])

    useEffect(() => {
        fetchPaymentIntent()
    }, [fetchPaymentIntent])

    return { paymentIntent, error, loading, fetchPaymentIntent }
}

export default usePayment
